import { AlgoliaEvents, useAlgoliaIndex } from "@entities/algolia";
import { HighlightedText } from "@shared/ui";
import { PinLocationIcon } from "@shared/ui/custom-icon";
import { getSlug, imageFallback } from "@shared/utils";
import { AlgoliaHit } from "instantsearch.js";
import Image from "next/image";
import Link from "next/link";
import { Index, useHits } from "react-instantsearch";

type GovernmentHit = AlgoliaHit<{
  id: string;
  name: string;
  logo_uri: string;
  city_name: string;
  employer_id: string;
}>;

function GovernmentHits({ onClick }: { onClick: () => void }) {
  const { items, results, sendEvent } = useHits<GovernmentHit>();

  const handleClick = (hit: GovernmentHit) => {
    if (onClick) {
      onClick();
    }

    sendEvent("click", hit as any, AlgoliaEvents.GOVERNMENT_EMPLOYER_CLICKED);
  };

  if (items.length <= 0) {
    return <></>;
  }

  return (
    <div>
      <h4 className="p-3 font-bold text-lg">Instansi Pemerintah</h4>
      {items.map((it) => {
        return (
          <Link
            key={it.id}
            href={`/instansi-pemerintah/${getSlug(it.id, it.name)}`}
            className="flex items-start hover:bg-gray-200 rounded-lg p-3 gap-3"
            onClick={() => handleClick(it)}
          >
            <Image
              src={it.logo_uri || "/blank-white.webp"}
              className="w-12 h-12 min-w-12 rounded-lg bg-gray-100 object-cover border border-gray-200 mt-0.5"
              width="48"
              height="48"
              alt={it.name}
              onError={imageFallback()}
            />
            <div className="flex-1">
              <div className="font-semibold text-base">
                {results?.query ? <HighlightedText keyword={results?.query} text={it.name} /> : it.name}
              </div>
              {it.city_name && (
                <div className="mt-2 text-xs flex items-start gap-1">
                  <PinLocationIcon className="size-3 min-w-3 mt-0.5" />
                  <span className="flex-1">{it.city_name}</span>
                </div>
              )}
            </div>
          </Link>
        );
      })}
    </div>
  );
}

export function AlgoliaGovernmentResult({ onClick }: { onClick: () => void }) {
  const { government } = useAlgoliaIndex();

  return (
    <Index indexName={government}>
      <GovernmentHits onClick={onClick} />
    </Index>
  );
}
